import React, { useCallback, useMemo } from 'react';
import cn from 'classnames';
import { ArrowForward } from "../../../icons";
import { getTestIds } from "../../../utils/TestIds";
import { useBiClick } from "../../BiTracking";
import { ConditionalWrapper } from "../../ConditionalWrapper";
import { useIntentBehavior } from "../../IntentBehavior";
import { Tooltip } from "../../Tooltip";
import { Typography } from "../../Typography";
import styles from "./MenuPromotionalAction.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GetMenuPromotionalActionTID = parentTestId => getTestIds(parentTestId);
export function MenuPromotionalAction(props) {
  const {
    title,
    body,
    testId,
    intent,
    onClick,
    onMouseDown,
    className,
    bi
  } = props;
  const {
    getDisabled,
    getTooltip
  } = useIntentBehavior();
  const disabledFromIntent = intent ? getDisabled(intent) : false;
  const tooltipFromIntent = intent ? getTooltip(intent) : null;
  const {
    MenuPromotionalActionTID
  } = useMemo(() => GetMenuPromotionalActionTID(testId), [testId]);
  const logBiClick = useBiClick();
  const handleClick = useCallback(() => {
    if (bi !== null && bi !== void 0 && bi.name) {
      logBiClick({
        entityType: 'button',
        entityName: bi.name,
        actionType: 'click',
        data: bi.data
      });
    }
    onClick === null || onClick === void 0 || onClick();
  }, [bi, logBiClick, onClick]);
  return /*#__PURE__*/_jsx(ConditionalWrapper, {
    condition: !!tooltipFromIntent,
    wrapper: children => /*#__PURE__*/_jsx(Tooltip, {
      "data-testid": MenuPromotionalActionTID.Tooltip(),
      placement: "top",
      title: tooltipFromIntent || '',
      children: /*#__PURE__*/_jsx("div", {
        children: children
      })
    }),
    children: /*#__PURE__*/_jsx("div", {
      className: className === null || className === void 0 ? void 0 : className.wrapper,
      children: /*#__PURE__*/_jsxs("button", {
        className: cn(styles.root, className === null || className === void 0 ? void 0 : className.button),
        "data-testid": MenuPromotionalActionTID.Root(),
        disabled: disabledFromIntent,
        onClick: handleClick,
        onMouseDown: onMouseDown,
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Typography, {
            weight: "normal",
            skin: "primary",
            variant: "paragraph1",
            children: title
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "paragraph2",
            weight: "light",
            style: {
              whiteSpace: 'pre-line'
            },
            children: body
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: styles.iconWrapper,
          children: /*#__PURE__*/_jsx(ArrowForward, {})
        })]
      })
    })
  });
}